/* eslint-disable quotes */
import { SECTION_TYPES } from "@/lib/constants/sections";
import { Map } from "lucide-react";

const mapSection = {
  type: SECTION_TYPES.MAP,
  content: {
    header: "Reach out to us",
    showEmail: false,
  },
  meta: {
    displayName: "Map",
    displayDescription: "Let your customers know where and how to find you.",
    displayIcon: Map,
    variantsCount: 2,
  },
  aiPrompt() {
    return `This section will sometimes show hours of operation, sometimes show a service area map, sometimes phone number, sometimes email, etc. 
    We never know which it will be so let's create a header that's all encompassing (and short!) like "Get in touch with us" or "We're here to help".`;
  },
};

export default mapSection;
